import {useEffect} from "react";
import {router} from "@inertiajs/react";
import {inertiaEvents, navigationEvents} from "@/shared/lib/events";
import {stopNavigationLoader} from "@/shared/lib/navigation/navigationLoader";

export const useInertiaNavigation = () => {
    useEffect(() => {
        const start = () => {
            inertiaEvents.started.emit();
        };

        const finish = () => {
            stopNavigationLoader();
            inertiaEvents.finished.emit();
        };

        const cancel = () => {
            stopNavigationLoader();
            inertiaEvents.canceled.emit();
        };

        const error = () => {
            stopNavigationLoader();
            inertiaEvents.errored.emit();
        };

        const navigate = () => {
            navigationEvents.pageChanged.emit();
        };

        const offStart = router.on("start", start);
        const offFinish = router.on("finish", finish);
        const offCancel = router.on("cancel", cancel);
        const offError = router.on("error", error);
        const offNavigate = router.on("navigate", navigate);

        return () => {
            offStart();
            offFinish();
            offCancel();
            offError();
            offNavigate();
        };

    }, []);
}
